import type { TFunction } from 'i18next';

const DEFAULT_ERROR_MESSAGE_KEY = 'common:errors.unexpectedRequest';
const DEFAULT_ERROR_MESSAGE =
  'Something went wrong while processing your request.';

export function getErrorMessage(
  error: unknown,
  t: TFunction,
  fallback?: string | null,
): string | null {
  if (typeof error === 'string') {
    const message = error.trim();

    if (message.length > 0) {
      return message;
    }
  }

  if (error instanceof Error) {
    const message = error.message.trim();

    if (message.length > 0) {
      return message;
    }
  }

  if (fallback !== undefined) {
    return fallback;
  }

  return t(DEFAULT_ERROR_MESSAGE_KEY, DEFAULT_ERROR_MESSAGE);
}
